<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Danh sách tài sản</h4>
          </div>
          <div class="text-right">
            <div>
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                round
                class="btn-default"
                >Ẩn/hiện tìm kiếm</el-button
              >
              <el-button
                round
                class="btn-default"
                @click="fn_handle('create')"
                v-if="mData.dataDefault.listFeature.includes('FT1602')"
                >Thêm mới</el-button
              >
            </div>
          </div>
        </div>
        <div class="main-body mt-1">
          <!-- Form search -->
          <div class="main-body-search">
            <b-collapse
              :visible.sync="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="mb-3"
            >
              <el-card>
                <el-form
                  ref="mySearchForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="2">
                      <el-form-item label="Tên nhân viên" prop="emp_names">
                        <el-input
                          type="text"
                          v-model="mData.tableRules.dataSearch.value.emp_names"
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Tên tài sản" prop="asset_names">
                        <el-input
                          type="text"
                          v-model="
                            mData.tableRules.dataSearch.value.asset_names
                          "
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Serial number" prop="identity">
                        <el-input
                          type="text"
                          v-model.trim="
                            mData.tableRules.dataSearch.value.identity
                          "
                          @change="
                            () =>
                              (mData.tableRules.dataSearch.value.identity =
                                mData.tableRules.dataSearch.value.identity.toUpperCase())
                          "
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Trạng thái" prop="status">
                        <el-select
                          filterable
                          clearable
                          multiple
                          v-model="mData.dataDefault.listStatusFilter"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="2">
                      <el-form-item label="Hỏng" prop="is_broken">
                        <el-select
                          filterable
                          clearable
                          v-model="mData.tableRules.dataSearch.value.is_broken"
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listStatusAsset"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      round
                      native-type="submit"
                      type="primary"
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </el-card>
            </b-collapse>
          </div>
          <!-- Assets Table -->
          <div class="main-body-table">
            <el-table
              :data="mData.tableRules.data"
              border
              @sort-change="fn_tableSortChange"
              style="width: 100%"
              max-height="490"
              :cell-class-name="fn_getCellClass"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column prop="" label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.skip + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.name"
                label="Tên tài sản"
                min-width="160"
                fixed
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.asset.name"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.asset.name
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.identity"
                label="Serial number"
                align="center"
                min-width="105"
                fixed
              ></el-table-column>
              <el-table-column
                prop="asset.status"
                label="Trạng thái"
                min-width="160"
                fixed
              >
                <template slot-scope="scope">
                  <span
                    class="bold"
                    :class="fn_setStatusColor(scope.row.asset.status)"
                    >{{ fn_changeDataStatus(scope.row.asset.status) }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.description"
                label="Mô tả"
                min-width="200"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.asset.description"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.asset.description
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="asset.origin_price"
                label="Giá ban đầu"
                min-width="95"
                align="right"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="fn_formatCurrency(scope.row.asset.origin_price)"
                  >
                    <span class="content" slot="reference">{{
                      fn_formatCurrency(scope.row.asset.origin_price)
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="asset.is_atrophy"
                label="Tiêu hao"
                min-width="70"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.asset.is_atrophy ? 'Có' : 'Không'"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.asset.is_atrophy ? "Có" : "Không"
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column> -->
              <el-table-column
                prop="asset.expired_atrophy"
                label="Ngày mua"
                min-width="85"
                align="center"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="fn_formatDate(scope.row.asset.expired_atrophy)"
                  >
                    <span class="content" slot="reference">{{
                      fn_formatDate(scope.row.asset.expired_atrophy)
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="employee_name"
                label="Tên nhân viên"
                min-width="160"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="
                      scope.row.employee_name ? scope.row.employee_name : ''
                    "
                  >
                    <span class="content" slot="reference">{{
                      scope.row.employee_name ? scope.row.employee_name : ""
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="Hỏng" width="60" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.asset.is_broken"
                    @change="
                      fn_changeTrangThaiKhoa(
                        scope.row,
                        scope.row.id,
                        scope.row.asset.is_broken
                      )
                    "
                    :disabled="
                      !mData.dataDefault.listFeature.includes('FT1602') ||
                      scope.row.asset.status != 'BROKEN_CONFIRMED'
                    "
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="left"
                min-width="600"
                v-if="
                  mData.dataDefault.listFeature.includes('FT1602') ||
                  mData.dataDefault.listFeature.includes('FT1603') ||
                  mData.dataDefault.listFeature.includes('FT1604') ||
                  mData.dataDefault.listFeature.includes('FT1605') ||
                  mData.dataDefault.listFeature.includes('FT1606') ||
                  mData.dataDefault.listFeature.includes('FT1607') ||
                  mData.dataDefault.listFeature.includes('FT1608') ||
                  mData.dataDefault.listFeature.includes('FT1609')
                "
              >
                <template slot-scope="scope">
                  <div class="d-flex">
                    <!-- <div class="d-flex">
                      <el-link
                          type="primary"
                          @click="fn_delete(scope.row.asset.id)"
                          >Xóa</el-link
                        >
                      <div class="line"></div>
                    </div> -->
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="
                          !mData.dataDefault.listFeature.includes('FT1602') ||
                          scope.row.asset.status == 'BROKEN_REPORT' ||
                          scope.row.asset.status == 'RECALL_REPORT' ||
                          scope.row.asset.status == 'ALLOCATION_CONFIRMED' ||
                          scope.row.asset.status == 'LIQUIDATION' ||
                          scope.row.asset.status == 'OUT_OF_STOCK'
                        "
                        @click="fn_handle('update', scope.$index, scope.row)"
                        >Sửa</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        @click="fn_handle('detail', scope.$index, scope.row)"
                        >Xem</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="
                          !mData.dataDefault.listFeature.includes('FT1607') ||
                          scope.row.asset.status == 'BROKEN_REPORT' ||
                          scope.row.asset.status == 'BROKEN_CONFIRMED' ||
                          scope.row.asset.status == 'RECALL_REPORT' ||
                          scope.row.asset.status == 'ALLOCATION_CONFIRMED' ||
                          scope.row.asset.status == 'LIQUIDATION' ||
                          scope.row.asset.status == 'OUT_OF_STOCK'
                        "
                        @click="
                          fn_handle(
                            'allocation_request',
                            scope.$index,
                            scope.row
                          )
                        "
                        >Cấp phát</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="
                          !mData.dataDefault.listFeature.includes('FT1603') ||
                          scope.row.asset.status == 'BROKEN_REPORT' ||
                          scope.row.asset.status == 'BROKEN_CONFIRMED' ||
                          scope.row.asset.status == 'RECALL_REPORT' ||
                          scope.row.asset.status == 'RECALL_CONFIRMED' ||
                          scope.row.asset.status == 'ALLOCATION_REQUEST' ||
                          scope.row.asset.status == 'LIQUIDATION' ||
                          scope.row.asset.status == 'OUT_OF_STOCK'
                        "
                        @click="
                          fn_handle('broken_report', scope.$index, scope.row)
                        "
                        >Báo hỏng</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="
                          !mData.dataDefault.listFeature.includes('FT1604') ||
                          scope.row.asset.status == 'NEW' ||
                          scope.row.asset.status == 'BROKEN_CONFIRMED' ||
                          scope.row.asset.status == 'RECALL_REPORT' ||
                          scope.row.asset.status == 'RECALL_CONFIRMED' ||
                          scope.row.asset.status == 'ALLOCATION_REQUEST' ||
                          scope.row.asset.status == 'ALLOCATION_CONFIRMED' ||
                          scope.row.asset.status == 'LIQUIDATION' ||
                          scope.row.asset.status == 'OUT_OF_STOCK'
                        "
                        @click="
                          fn_handle('broken_confirmed', scope.$index, scope.row)
                        "
                        >Xác nhận hỏng</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="
                          !mData.dataDefault.listFeature.includes('FT1605') ||
                          scope.row.asset.status == 'NEW' ||
                          scope.row.asset.status == 'BROKEN_REPORT' ||
                          scope.row.asset.status == 'RECALL_REPORT' ||
                          scope.row.asset.status == 'RECALL_CONFIRMED' ||
                          scope.row.asset.status == 'ALLOCATION_REQUEST' ||
                          scope.row.asset.status == 'LIQUIDATION' ||
                          scope.row.asset.status == 'OUT_OF_STOCK'
                        "
                        @click="
                          fn_handle('recall_report', scope.$index, scope.row)
                        "
                        >Thu hồi</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <div class="d-flex">
                      <el-link
                        type="primary"
                        :disabled="
                          !mData.dataDefault.listFeature.includes('FT1606') ||
                          scope.row.asset.status == 'NEW' ||
                          scope.row.asset.status == 'BROKEN_REPORT' ||
                          scope.row.asset.status == 'BROKEN_CONFIRMED' ||
                          scope.row.asset.status == 'RECALL_CONFIRMED' ||
                          scope.row.asset.status == 'ALLOCATION_REQUEST' ||
                          scope.row.asset.status == 'ALLOCATION_CONFIRMED' ||
                          scope.row.asset.status == 'LIQUIDATION' ||
                          scope.row.asset.status == 'OUT_OF_STOCK'
                        "
                        @click="
                          fn_handle('recall_confirmed', scope.$index, scope.row)
                        "
                        >Xác nhận thu hồi</el-link
                      >
                      <div class="line"></div>
                    </div>
                    <el-link
                      type="primary"
                      :disabled="
                        !mData.dataDefault.listFeature.includes('FT1609') ||
                        scope.row.asset.status == 'BROKEN_REPORT' ||
                        scope.row.asset.status == 'BROKEN_CONFIRMED' ||
                        scope.row.asset.status == 'RECALL_REPORT' ||
                        scope.row.asset.status == 'ALLOCATION_REQUEST' ||
                        scope.row.asset.status == 'ALLOCATION_CONFIRMED' ||
                        scope.row.asset.status == 'LIQUIDATION' ||
                        scope.row.asset.status == 'OUT_OF_STOCK'
                      "
                      @click="fn_handle('liquidation', scope.$index, scope.row)"
                      >Thanh lý</el-link
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4">
                <div v-if="mData.tableRules.allowSelect">
                  {{ aLang.c_select }}:
                  {{ mData.tableRules.recordSelected.length }}
                </div>
              </div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="formDialog"
      top="5vh"
      width="50%"
      @close="fn_cancel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="formCreateAsset"
          @submit.native.prevent
          label-width="160px"
          label-position="top"
          v-if="
            mData.viewMode == 'create' ||
            mData.viewMode == 'update' ||
            mData.viewMode == 'detail'
          "
        >
          <el-dialog
            title="Ảnh xem trước"
            :visible.sync="mData.fileUploadOption.Anh.dialogVisible"
            :before-close="closeDialogImage"
            top="5vh"
            append-to-body
            class="centerInner"
          >
            <el-image
              :src="mData.fileUploadOption.Anh.dialogImageUrl"
              lazy
              alt="Ảnh xem trước...">
            </el-image>
          </el-dialog>
          <b-row class="mb-1">
            <b-col md="4" v-if="aRole('AdminSystem')">
              <el-form-item label="Tên công ty" prop="company_id">
                <el-select
                  v-model="mData.dataForm.company_id"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.viewMode == 'create'
                      ? mData.dataDefault.listCompany
                      : mData.dataDefault.listCompanyUpdate"
                    :key="item.id"
                    :label="item.name.name_vi"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên tài sản" prop="name">
                <el-input
                  type="text"
                  v-model="mData.dataForm.name"
                  :disabled="mData.viewMode == 'detail'"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Serial number" prop="identity">
                <el-input
                  type="text"
                  v-model.trim="mData.dataForm.identity"
                  :disabled="mData.viewMode == 'detail'"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Trạng thái" prop="status">
                <el-select
                  filterable
                  clearable
                  v-model="mData.dataForm.status"
                  :disabled="
                    mData.viewMode == 'detail' || mData.viewMode == 'create'
                  "
                >
                  <el-option
                    v-for="item in mData.viewMode == 'update'
                      ? mData.dataDefault.listRespectiveStatus
                      : mData.dataDefault.listStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="4">
              <el-form-item label="Giá ban đầu" prop="">
                <ElementUIMoney
                  v-model="mData.dataForm.origin_price"
                  label=""
                  :disabled="mData.viewMode == 'detail'"
                  :outlined="true"
                  :clearable="true"
                  :options="options"
                />
              </el-form-item>
            </b-col>
            <!-- <b-col md="4">
              <el-form-item label="Tiêu hao" prop="">
                <el-select
                  filterable
                  clearable
                  v-model="mData.dataForm.is_atrophy"
                  :disabled="mData.viewMode == 'detail'"
                  @change="fn_clearExpiredAtrophy"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listAtrophy"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col> -->
            <b-col md="4" >
              <el-form-item label="Ngày mua" prop="">
                <el-date-picker
                  type="date"
                  v-model="mData.dataForm.expired_atrophy"
                  :disabled="mData.viewMode == 'detail'"
                  placeholder=""
                  :clearable="false"
                  format="dd/MM/yyyy"
                  :picker-options="pickerOptionFrom"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col>
              <el-upload
                ref="upload"
                class="upload-demo"
                action
                multiple
                :auto-upload="false"
                :accept="mData.fileUploadOption.Anh.accept"
                :on-preview="fn_uploadPreviewAnh"
                :on-change="fn_uploadChangeFile"
                :on-remove="fn_removeFile"
                :file-list="mData.fileUploadOption.Anh.fileList"
                :disabled="mData.viewMode == 'detail'"
              >
                <el-button
                  size="small"
                  class="btn-default"
                  :disabled="mData.viewMode == 'detail'"
                >
                  Tải ảnh lên <i class="isax-arrow-up-3"></i>
                </el-button>
              </el-upload>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="12">
              <el-form-item label="Mô tả" prop="description">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.description"
                  :disabled="mData.viewMode == 'detail'"
                  resize="none"
                  :autosize="{ minRows: 3, maxRows: 3 }"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <!-- Table Xem lịch sử-->
          <div
            class="main-body-table pr-3 pl-3 mb-1"
            v-if="mData.viewMode == 'detail'"
          >
            <el-table
              :data="mData.dataDefault.listAllHistory"
              @sort-change="fn_tableSortChange"
              border
              style="width: 100%"
              max-height="200px"
            >
              <el-table-column prop="" label="STT" width="45">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="requested_date"
                label="Thời điểm"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="
                      fn_formatDatetime(
                        scope.row.requested_date
                          ? scope.row.requested_date
                          : scope.row.confirmed_date
                      )
                    "
                  >
                    <span class="content" slot="reference">{{
                      fn_formatDatetime(
                        scope.row.requested_date
                          ? scope.row.requested_date
                          : scope.row.confirmed_date
                      )
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="Thao tác" min-width="140">
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="fn_changeDataStatus(scope.row.status)"
                  >
                    <span
                      class="content bold"
                      slot="reference"
                      :class="fn_setStatusColor(scope.row.status)"
                      >{{ fn_changeDataStatus(scope.row.status) }}</span
                    >
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="employee_name"
                label="Nhân viên"
                min-width="180"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.employee_name"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.employee_name
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column
                prop="description"
                label="Ghi chú"
                min-width="110"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    :open-delay="800"
                    :content="scope.row.description"
                  >
                    <span class="content" slot="reference">{{
                      scope.row.description
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <!-- <el-table-column label="Thao tác" align="center">
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    @click="fn_delHistory(scope.row.id)"
                    >Xóa</el-link
                  >
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </el-form>
      </div>

      <!-- Form thao tác -->
      <div>
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="formManipulation"
          @submit.native.prevent
          label-width="160px"
          label-position="top"
          v-if="
            mData.viewMode == 'allocation_request' ||
            mData.viewMode == 'recall_report' ||
            mData.viewMode == 'recall_confirmed' ||
            mData.viewMode == 'broken_report' ||
            mData.viewMode == 'broken_confirmed' ||
            mData.viewMode == 'liquidation'
          "
        >
          <b-row
            class="mb-1"
            v-if="
              mData.viewMode == 'allocation_request' ||
              mData.viewMode == 'recall_report' ||
              mData.viewMode == 'recall_confirmed' ||
              mData.viewMode == 'broken_report' ||
              mData.viewMode == 'broken_confirmed'
            "
          >
            <b-col md="12">
              <el-form-item
                :label="
                  mData.viewMode == 'allocation_request'
                    ? 'Người nhận tài sản'
                    : 'Người đang sở hữu'
                "
                :prop="
                  mData.viewMode == 'allocation_request' ? 'employee_id' : ''
                "
              >
                <el-select
                  filterable
                  :disabled="
                    mData.viewMode == 'recall_report' ||
                    mData.viewMode == 'recall_confirmed' ||
                    mData.viewMode == 'broken_report' ||
                    mData.viewMode == 'broken_confirmed'
                  "
                  v-model="mData.dataForm.employee_id"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listEmployee"
                    :key="item.id"
                    :label="fn_setLabelRespectively(item)"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="12">
              <el-form-item label="Tài sản" prop="asset_id">
                <el-select
                  v-model="mData.dataForm.asset_id"
                  filterable
                  disabled
                >
                  <el-option
                    v-for="item in mData.tableRules.data"
                    :key="item.id"
                    :label="item.asset.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col md="12">
              <el-form-item label="Ghi chú" prop="">
                <el-input
                  type="textarea"
                  v-model="mData.dataForm.descriptionEmployeeAsset"
                  :disabled="mData.viewMode == 'detail'"
                  resize="none"
                  :autosize="{ minRows: 3, maxRows: 3 }"
                  placeholder=""
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <!-- Button -->
      <div class="text-center mt-2">
        <el-button
          round
          class="btn-back"
          @click="fn_cancel"
          v-if="
            mData.viewMode == 'allocation_request' ||
            mData.viewMode == 'recall_report' ||
            mData.viewMode == 'broken_report' ||
            mData.viewMode == 'liquidation' ||
            mData.viewMode == 'create' ||
            mData.viewMode == 'update'
          "
          native-type="submit"
          >Bỏ qua</el-button
        >
        <el-button
          round
          class="btn-default"
          @click="fn_submitForm('create')"
          v-if="mData.viewMode == 'create'"
          native-type="submit"
          >Lưu</el-button
        >
        <el-button
          round
          class="btn-default"
          @click="fn_submitForm('update')"
          v-if="mData.viewMode == 'update'"
          native-type="submit"
          >Cập nhật</el-button
        >
        <el-button
          round
          class="btn-default"
          @click="fn_submitForm(mData.viewMode)"
          v-if="
            mData.viewMode == 'allocation_request' ||
            mData.viewMode == 'recall_report' ||
            mData.viewMode == 'broken_report'
          "
          native-type="submit"
          >Thêm yêu cầu</el-button
        >
        <el-button
          round
          class="btn-back"
          @click="fn_rejectRequest"
          v-if="
            mData.viewMode == 'recall_confirmed' ||
            mData.viewMode == 'broken_confirmed'
          "
          native-type="submit"
          >Từ chối</el-button
        >
        <el-button
          round
          class="btn-default"
          @click="fn_submitForm(mData.viewMode)"
          v-if="
            mData.viewMode == 'recall_confirmed' ||
            mData.viewMode == 'broken_confirmed' ||
            mData.viewMode == 'liquidation'
          "
          native-type="submit"
          >Xác nhận</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ExtensionService from "../../../service/ExtensionService";
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ValidService from "../../../service/ValidService";
import AssetModel from "./AssetModel";
import AssetApi from "../../../moduleApi/AssetApi";
import EmployeeAssetApi from "../../../moduleApi/EmployeeAssetApi";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import FileApi from "../../../moduleApi/FileApi";
import ElementUIMoney from "../../../component/InputComponent/ElementUiMoney";

export default {
  components: {
    ElementUIMoney,
  },
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      formDialog: false,
      dialogTitle: "",
      mData: {
        id: null,
        viewMode: "create",
        moduleName: "Asset",
        dataForm: MethodService.copyObject(AssetModel.dataForm),
        validForm: AssetModel.validForm,
        tableRules: MethodService.copyObject(AssetModel.tableRules),
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        dataDefault: {
          listStatus: DataService.listStatus,
          listCompany: [],
          listCompanyUpdate: [],
          listEmployee: [],
          listEmployeeAsset: [],
          listAllHistory: [],
          listHistoryExcept: [],
          listRespectiveStatus: [],
          listStatusFilter: [],
          listStatusAsset: [
            {
              label: "Hỏng",
              value: true,
            },
            {
              label: "Không hỏng",
              value: false,
            },
          ],
          listFeature: MethodService.getListFeatures(),
          listTrangThaiKhoa: DataService.listTrangThaiKhoa,
          listAtrophy: [
            {
              label: "Có",
              value: true,
            },
            {
              label: "Không",
              value: false,
            },
          ],
        },
        fileUploadOption: {
          dialogImageUrl: "",
          dialogVisible: false,
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
        companyInfo: {},
      },
      options: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 100,
        precision: 0,
      },
      pickerOptionFrom: {
        disabledDate(time) {
          return (
            time.getTime() <
            new Date(new Date().valueOf() - 1000 * 60 * 60 * 24).getTime()
          );
        },
      },
      dataFilter: {},
    };
  },

  methods: {
    fn_setLabelRespectively(item) {
      return `${item.employee_no ? item.employee_no + " - ": ''} ${item.administrative_info.name.full_name ? item.administrative_info.name.full_name : ''}`;
    },

    async fn_getListEmployee() {
      let dataFilter = {
        filters:
          "company_id=" +
          this.mData.currentCompany.id +
          "&disabled=false" +
          "&status=DANG_LAM_VIEC",
        fields: "id,employee_no,administrative_info,company_id,status,disabled",
        limit: 3000,
      };
      const employeeApiRes = await EmployeeApi.list(dataFilter);
      if (employeeApiRes.result) {
        this.mData.dataDefault.listEmployee = employeeApiRes.result;
      }
    },

    async fn_getListEmployeeAsset() {
      const employeeAssetApi = await EmployeeAssetApi.list({
        sort: "-requested_date,-confirmed_date",
        limit: 9999,
      });
      if (employeeAssetApi.result) {
        this.mData.dataDefault.listEmployeeAsset = employeeAssetApi.result;
      }
    },

    async fn_initDataDefault() {
      await this.fn_getListEmployee();
      await this.fn_getListEmployeeAsset();
    },

    async fn_initTable() {
      this.dataFilter = {
        ...this.dataFilter,
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        this.dataFilter.limit = this.mData.tableRules.limit;
        this.dataFilter.skip = this.mData.tableRules.skip;
        this.dataFilter.page = this.mData.tableRules.page;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              ...this.dataFilter,
            },
          })
          .catch((err) => {});
      }
      const res = await AssetApi.GetListAsset(this.dataFilter);
      this.mData.tableRules.total = res.result.total;
      if (res.result && res.result.lstAssets.length > 0) {
        this.mData.tableRules.data = res.result.lstAssets;
        this.mData.tableRules.page =
          this.mData.tableRules.skip / this.mData.tableRules.limit + 1;
      } else {
        this.mData.tableRules.data = [];
      }
      if (
        this.mData.tableRules.skip == this.mData.tableRules.total &&
        this.mData.tableRules.page > 1
      ) {
        this.mData.tableRules.page = this.mData.tableRules.page - 1;
        this.mData.tableRules.skip =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
        await this.fn_initTable();
      }
    },

    fn_changeDataStatus(status) {
      return status == "NEW"
        ? "Mới"
        : status == "BROKEN_REPORT"
        ? "Báo hỏng"
        : status == "BROKEN_CONFIRMED"
        ? "Xác nhận hỏng"
        : status == "RECALL_REPORT"
        ? "Báo thu hồi"
        : status == "RECALL_CONFIRMED"
        ? "Xác nhận thu hồi"
        : status == "ALLOCATION_REQUEST"
        ? "Báo cấp phát"
        : status == "ALLOCATION_CONFIRMED"
        ? "Xác nhận cấp phát"
        : status == "LIQUIDATION"
        ? "Thanh lý"
        : status == "ALLOCATION_REJECTED"
        ? "Từ chối cấp phát"
        : status == "RECALL_REJECTED"
        ? "Từ chối thu hồi"
        : status == "BROKEN_REJECTED"
        ? "Từ chối báo hỏng"
        : status == "OUT_OF_STOCK"
        ? "Hết"
        : "";
    },
    //search
    fn_tableSearch() {
      this.$refs["mySearchForm"].validate(async (valid) => {
        if (!valid) {
          MethodService.stopLadda();
          return false;
        }
        let dataSearch = this.mData.tableRules.dataSearch;
        if (dataSearch.value.emp_names) {
          this.dataFilter.emp_names = MethodService.changeAlias(
            dataSearch.value.emp_names
          ).split(" ");
        } else {
          delete this.dataFilter.emp_names;
        }
        if (dataSearch.value.asset_names) {
          this.dataFilter.asset_names = MethodService.changeAlias(
            dataSearch.value.asset_names
          ).split(" ");
        } else {
          delete this.dataFilter.asset_names;
        }
        if (dataSearch.value.identity) {
          this.dataFilter.identity = dataSearch.value.identity.trim();
        } else {
          delete this.dataFilter.identity;
        }
        if (this.mData.dataDefault.listStatusFilter.length > 0) {
          // dataSearch.value.status =
          //   this.mData.dataDefault.listStatusFilter.join(",");
          this.dataFilter.status = this.mData.dataDefault.listStatusFilter;
        } else {
          delete this.dataFilter.status;
        }
        if (dataSearch.value.is_broken !== "") {
          this.dataFilter.is_broken = dataSearch.value.is_broken;
        } else {
          delete this.dataFilter.is_broken;
        }
        // this.mData.tableRules.filters = MethodService.filterTable(
        //   JSON.stringify(dataSearch)
        // );
        this.mData.tableRules.filters = this.mData.tableRules.filters.replace(
          "company_id=system",
          "company_id:is_null:true"
        );
        this.mData.tableRules.skip = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      });
    },
    //event table
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    async fn_changeTrangThaiKhoa(row, id, trangThai) {
      const data = {
        id: id,
        is_broken: trangThai,
        company_id: this.mData.currentCompany.id,
      };
      try {
        await AssetApi.update(data);
        await this.fn_initTable();
        window.toastr.success("Cập nhật thành công");
      } catch (error) {
        console.log(error);
      }
    },

    async fn_getHistoryAsset(id) {
      this.mData.dataDefault.listAllHistory = [];
      this.mData.dataDefault.listHistoryExcept = [];
      const employeeAssetApi = await EmployeeAssetApi.list({
        filters: `asset_id=${id}`,
      });
      if (employeeAssetApi.result) {
        employeeAssetApi.result.forEach((el1) => {
          this.mData.dataDefault.listEmployee.forEach((el2) => {
            if (el1.employee_id == el2.id) {
              el1.employee_name = el2.administrative_info.name.full_name;
            }
          });
        });
        this.mData.dataDefault.listAllHistory = employeeAssetApi.result;
        this.mData.dataDefault.listHistoryExcept =
          employeeAssetApi.result.filter(
            (el) =>
              el.status != "ALLOCATION_REJECTED" &&
              el.status != "RECALL_REJECTED" &&
              el.status != "BROKEN_REJECTED"
          );
      }
    },

    fn_addCompanyToListEmployee(type) {
      if (type != "allocation_request") {
        const e = this.mData.dataDefault.listEmployee.find(emp => emp.id == this.mData.currentCompany.id);
        if (!e) {
          this.mData.dataDefault.listEmployee.push({
            id: this.mData.currentCompany.id,
            administrative_info: {
              name: {
                full_name: this.mData.currentCompany.name.name_vi,
              }
            }
          })
        }
      } else {
        const indexOfObject = this.mData.dataDefault.listEmployee.findIndex(o => o.id == this.mData.currentCompany.id);
        if (indexOfObject != -1) this.mData.dataDefault.listEmployee.splice(indexOfObject, 1);
      }
    },

    async fn_handle(type, scope, row) {
      this.formDialog = true;
      this.mData.viewMode = type;
      this.mData.dataForm.description = '';
      this.fn_addCompanyToListEmployee(type);
      if (type == "create") {
        this.mData.dataForm.status = this.mData.dataDefault.listStatus[0].value;
      } else if (type == "update") {
        this.mData.id = row.id;
        this.fn_getAssetById(row.id);
        this.mData.dataDefault.listRespectiveStatus =
          this.fn_setListRespectiveStatus(row.asset.status);
      } else if (type == "detail") {
        this.mData.id = row.id;
        await this.fn_getHistoryAsset(row.id);
        await this.fn_getAssetById(row.id);
      } else if (type == "allocation_request") {
        this.mData.dataForm.asset_id = row.id;
        this.mData.dataForm.status = row.status;
      } else if (type == "broken_report") {
        this.mData.dataForm.asset_id = row.id;
        this.mData.dataForm.employee_id = row.employee_id
          ? row.employee_id
          : "";
      } else if (type == "broken_confirmed") {
        this.mData.id = row.id;
        this.fn_getHistoryAsset(row.id);
        this.mData.dataForm.asset_id = row.id;
        this.mData.dataForm.employee_id = row.employee_id
          ? row.employee_id
          : "";
      } else if (type == "recall_report") {
        this.mData.dataForm.employee_id = row.employee_id
          ? row.employee_id
          : "";
        this.mData.dataForm.asset_id = row.id;
        this.mData.dataForm.status = row.status;
      } else if (type == "recall_confirmed") {
        this.mData.id = row.id;
        this.fn_getHistoryAsset(row.id);
        this.mData.dataForm.asset_id = row.id;
        this.mData.dataForm.employee_id = row.employee_id
          ? row.employee_id
          : "";
      } else if (type == "liquidation") {
        this.mData.dataForm.asset_id = row.id;
      }
      if (this.mData.dataForm.employee_id) {
        this.mData.validForm.employee_id = [];
      } else {
        this.mData.validForm.employee_id = [ValidService.requiredChange];
        this.forceUpdateUI();
      }
      this.fn_setDialogTitle(this.mData.viewMode);
    },

    fn_setDataCreateEmployeeAsset(status) {
      let data = this.mData.dataForm;
      if (status == "ALLOCATION_REQUEST" || status == "ALLOCATION_CONFIRMED") {
        data.type = "ALLOCATION";
      } else if (status == "BROKEN_REPORT" || status == "BROKEN_CONFIRMED") {
        data.type = "BROKEN";
      } else if (status == "RECALL_REPORT" || status == "RECALL_CONFIRMED") {
        data.type = "RECALL";
      } else if (status == "LIQUIDATION") {
        data.type = "LIQUIDATION";
      } else if (status == "NEW") {
        data.type = "NEW";
      }
      if (
        status == "ALLOCATION_REQUEST" ||
        status == "RECALL_REPORT" ||
        status == "BROKEN_REPORT"
      ) {
        data.requested_date = new Date();
        data.requested_user_id = this.mData.currentUser.id;
      } else {
        data.confirmed_date = new Date();
        data.confirmed_user_id = this.mData.currentUser.id;
      }
      const dataEmployeeAsset = {
        asset_id: this.mData.id,
        company_id: this.mData.currentCompany.id,
        type: data.type,
        status: status,
        requested_date: data.requested_date ? data.requested_date : null,
        requested_user_id: data.requested_date
          ? this.mData.currentUser.id
          : null,
        confirmed_date: data.confirmed_date ? data.confirmed_date : null,
        confirmed_user_id: data.confirmed_date
          ? this.mData.currentUser.id
          : null,
      };
      return dataEmployeeAsset;
    },

    fn_submitForm(type) {
      let data = this.mData.dataForm;
      let dataUpdateAsset = {};
      data.company_id = this.mData.currentCompany.id;
      data.name = data.name ? data.name.trim() : "";
      data.description = data.description ? data.description.trim() : "";
      data.identity = data.identity ? data.identity.toUpperCase() : "";
      if (type == "create" || type == "update") {
        this.$refs["formCreateAsset"].validate(async (valid) => {
          if (!valid) {
            MethodService.stopLadda();
            return false;
          }
          try {
            data.status_order = this.fn_setStatusOrder(data.status);
            data.origin_price = data.origin_price
              ? parseFloat(data.origin_price)
              : undefined;
            if (type == "create") {
              await AssetApi.create(data);
            }
            if (type == "update") {
              data.id = this.mData.id;
              const dataEmployeeAsset = this.fn_setDataCreateEmployeeAsset(
                data.status
              );
              // console.log("dataEmployeeAsset",dataEmployeeAsset);
              // console.log("data", data);
              await AssetApi.update(data);
              await EmployeeAssetApi.create(dataEmployeeAsset);
              window.toastr.success(`Cập nhật thành công`);
            }
            await this.fn_resetFormCreateAsset();
            await this.fn_getListEmployeeAsset();
            await this.fn_initTable();
            this.mData.viewMode = "create";
          } catch (error) {
            if (error && error.code === 500) {
              window.toastr.error("Serial number đã tồn tại");
            } else {
              if (type == "create") {
                window.toastr.error("Thêm mới thất bại");
              } else if (type == "update") {
                window.toastr.error("Cập nhật thất bại");
              }
            }
          }
        });
      } else {
        this.$refs["formManipulation"].validate(async (valid) => {
          if (!valid) {
            MethodService.stopLadda();
            return false;
          }
          try {
            if (
              type == "allocation_request" ||
              type == "recall_report" ||
              type == "broken_report"
            ) {
              data.requested_date = new Date();
              data.requested_user_id = this.mData.currentUser.id;
            } else {
              data.confirmed_date = new Date();
              data.confirmed_user_id = this.mData.currentUser.id;
            }
            if (type == "allocation_request") {
              data.type = "ALLOCATION";
              data.status = "ALLOCATION_REQUEST";
            } else if (type == "recall_report") {
              data.type = "RECALL";
              data.status = "RECALL_REPORT";
            } else if (type == "recall_confirmed") {
              data.type = "RECALL";
              data.status = "RECALL_CONFIRMED";
            } else if (type == "broken_report") {
              data.type = "BROKEN";
              data.status = "BROKEN_REPORT";
            } else if (type == "broken_confirmed") {
              data.type = "BROKEN";
              data.status = "BROKEN_CONFIRMED";
            } else if (type == "liquidation") {
              data.type = "LIQUIDATION";
              data.status = "LIQUIDATION";
            }
            dataUpdateAsset = {
              id: data.asset_id,
              status: data.status,
              status_order: this.fn_setStatusOrder(data.status),
            };
            data.description = data.descriptionEmployeeAsset
              ? data.descriptionEmployeeAsset
              : "";

            // console.log("dataUpdateAsset",dataUpdateAsset);
            // console.log("data", data);
            await AssetApi.update(dataUpdateAsset);
            await EmployeeAssetApi.create(data);
            window.toastr.success(`${this.fn_showTypeNoti(type)} thành công`);
            await this.fn_getListEmployeeAsset();
            await this.fn_initTable();
            await this.fn_resetFormManipulate();
            this.mData.viewMode = "create";
          } catch (error) {
            console.log("error", error);
          }
        });
      }
    },

    fn_setStatusOrder(statusType) {
      return statusType == "NEW"
        ? 0
        : statusType == "BROKEN_REPORT"
        ? 1
        : statusType == "BROKEN_CONFIRMED"
        ? 2
        : statusType == "RECALL_REPORT"
        ? 3
        : statusType == "RECALL_CONFIRMED"
        ? 4
        : statusType == "ALLOCATION_REQUEST"
        ? 5
        : statusType == "ALLOCATION_CONFIRMED"
        ? 6
        : statusType == "LIQUIDATION"
        ? 7
        : "";
    },

    fn_showTypeNoti(type) {
      return type == "allocation_request"
        ? "Báo cấp phát"
        : type == "broken_report"
        ? "Báo hỏng"
        : type == "broken_confirmed"
        ? "Xác nhận hỏng"
        : type == "recall_report"
        ? "Báo thu hồi"
        : type == "recall_confirmed"
        ? "Xác nhận thu hồi"
        : "Thanh lý";
    },

    fn_fillEmployeeId(status) {
      if (status == "NEW" || status == "ALLOCATION_REJECTED") {
        return null;
      }
      return this.mData.dataForm.employee_id;
    },

    async fn_rejectRequest() {
      try {
        let data = this.mData.dataForm;
        let obj = this.fn_setStatusAfterReject();
        const dataEmployeeAsset = {
          asset_id: this.mData.id,
          company_id: this.mData.currentCompany.id,
          employee_id: this.fn_fillEmployeeId(
            this.fn_setStatusEmployeeAssetReject()
          ),
          type: obj.type,
          status: this.fn_setStatusEmployeeAssetReject(),
          confirmed_date: new Date(),
          confirmed_user_id: this.mData.currentUser.id,
          description: data.descriptionEmployeeAsset
            ? data.descriptionEmployeeAsset.trim()
            : null,
        };
        // console.log("dataEmployeeAsset", dataEmployeeAsset);

        await EmployeeAssetApi.create(dataEmployeeAsset);
        await this.fn_getHistoryAsset(this.mData.id);
        obj = await this.fn_setStatusAfterReject();
        const dataUpdateAsset = {
          id: data.asset_id,
          status: obj.status,
          status_order: this.fn_setStatusOrder(obj.status),
        };
        // console.log("dataUpdateAsset", dataUpdateAsset);
        await AssetApi.update(dataUpdateAsset);
        this.fn_resetFormManipulate();
        window.toastr.success("Từ chối thành công");
        await this.fn_getListEmployeeAsset();
        await this.fn_initTable();
      } catch (error) {
        console.log("error", error);
      }
    },

    fn_setStatusAfterReject() {
      let obj = {};
      if (this.mData.dataDefault.listAllHistory.length < 3) {
        return (obj = { type: "NEW", status: "NEW" });
      }
      let lastStatus = null;
      let el = this.mData.dataDefault.listAllHistory;
      lastStatus = this.fn_getAssetStatusLog(el);
      obj = {
        type: lastStatus != null ? lastStatus.type : "NEW",
        status: lastStatus != null ? lastStatus.status : "NEW",
      };
      return obj;
    },

    fn_setStatusEmployeeAssetReject() {
      const lastStatus =
        this.mData.dataDefault.listHistoryExcept[
          this.mData.dataDefault.listHistoryExcept.length - 1
        ].status;
      let rejectStatus = "";
      if (lastStatus == "BROKEN_REPORT") {
        rejectStatus = "BROKEN_REJECTED";
      } else if (lastStatus == "RECALL_REPORT") {
        rejectStatus = "RECALL_REJECTED";
      } else if (lastStatus == "ALLOCATION_REQUEST") {
        rejectStatus = "ALLOCATION_REJECTED";
      }
      return rejectStatus;
    },

    fn_getAssetStatusLog(histories) {
      if (!histories || histories.length == 0) {
        return null;
      } else {
        let el = histories;
        for (let i = el.length - 1; i >= 0; i--) {
          if (
            el[i].status == "ALLOCATION_REJECTED" ||
            el[i].status == "RECALL_REJECTED" ||
            el[i].status == "BROKEN_REJECTED"
          ) {
            const newEl = el.slice(0, i - 1);
            return this.fn_getAssetStatusLog(newEl);
          } else {
            return el[i];
          }
        }
      }
    },

    async fn_delete(id) {
      try {
        await AssetApi.delete(id);
        this.fn_initTable();
        this.mData.viewMode = "create";
      } catch (error) {
        if (error && error.code && error.code === 500) {
          window.toastr.error(error.detail);
        } else {
          window.toastr.error("Xóa thất bại");
        }
      }
    },

    async fn_delHistory(id) {
      try {
        await EmployeeAssetApi.delete(id);
        await this.fn_getHistoryAsset(this.mData.id);
      } catch (error) {
        if (error && error.code && error.code === 500) {
          window.toastr.error(error.detail);
        } else {
          window.toastr.error("Xóa thất bại");
        }
      }
    },

    // Get the lastest record of EmployeeAsset
    // async fn_getRowEmployeeAsset(asset_id) {
    //   const dataFilter = {
    //     filters: `asset_id=${asset_id}`,
    //     sort: "-requested_date",
    //   };
    //   const employeeAssetApiRes = await EmployeeAssetApi.list(dataFilter);
    //   if (employeeAssetApiRes.result.length > 0) {
    //     // console.log(employeeAssetApiRes.result[0]);
    //     return employeeAssetApiRes.result[0].id;
    //   }
    // },

    async fn_getAssetById(id) {
      let res = await AssetApi.findById(id);
      if (res.result) {
        this.mData.dataForm = res.result;
      }
      if (
        this.mData.dataForm.file_ids &&
        this.mData.dataForm.file_ids.length > 0
      ) {
        const listFile = await FileApi.list(
          {
            limit: this.mData.dataForm.file_ids.length,
            filters: "id:in:" + this.mData.dataForm.file_ids.join(","),
          },
          true
        );
        let data = [];
        if (listFile && listFile.result) {
          data = listFile.result;
          data.map((item) => {
            item.url = ExtensionService.urlImg + item.id;
          });
        }
        this.mData.fileUploadOption.Anh.fileList = data;
      } else {
        this.mData.dataForm.file_ids = [];
      }
    },

    fn_formatDatetime(requested_date) {
      return MethodService.formatDate(requested_date, "datetime");
    },

    fn_setListRespectiveStatus(assetStatus) {
      let arr = [];
      if (assetStatus == "NEW") {
        arr = [
          {
            label: "Mới",
            value: "NEW",
          },
          {
            label: "Xác nhận hỏng",
            value: "BROKEN_CONFIRMED",
          },
          {
            label: "Xác nhận thu hồi",
            value: "RECALL_CONFIRMED",
          },
          {
            label: "Thanh lý",
            value: "LIQUIDATION",
          },
        ];
      } else if (assetStatus == "BROKEN_CONFIRMED") {
        arr = [
          {
            label: "Xác nhận hỏng",
            value: "BROKEN_CONFIRMED",
          },
          {
            label: "Xác nhận thu hồi",
            value: "RECALL_CONFIRMED",
          },
          {
            label: "Thanh lý",
            value: "LIQUIDATION",
          },
        ];
      } else if (assetStatus == "RECALL_CONFIRMED") {
        arr = [
          {
            label: "Xác nhận thu hồi",
            value: "RECALL_CONFIRMED",
          },
          {
            label: "Thanh lý",
            value: "LIQUIDATION",
          },
        ];
      } else {
        arr = [
          {
            label: "Báo cấp phát",
            value: "ALLOCATION_REQUEST",
          },
          {
            label: "Xác nhận cấp phát",
            value: "ALLOCATION_CONFIRMED",
          },
        ];
      }
      return arr;
    },

    fn_setStatusColor(status) {
      return status == "NEW"
        ? "new-asset"
        : status == "BROKEN_REPORT"
        ? "broken-report-asset"
        : status == "BROKEN_CONFIRMED"
        ? "broken-confirmed-asset"
        : status == "RECALL_REPORT"
        ? "recall-report-asset"
        : status == "RECALL_CONFIRMED"
        ? "recall-confirmed-asset"
        : status == "ALLOCATION_REQUEST"
        ? "allocation-request-asset"
        : status == "ALLOCATION_CONFIRMED"
        ? "allocation-confirmed-asset"
        : status == "LIQUIDATION"
        ? "liquidation-asset"
        : "";
    },

    fn_setDialogTitle(viewMode) {
      return (this.dialogTitle =
        viewMode == "create"
          ? "Thêm mới tài sản"
          : viewMode == "update"
          ? "Cập nhật tài sản"
          : viewMode == "detail"
          ? "Chi tiết tài sản"
          : viewMode == "allocation_request"
          ? "Thêm mới yêu cầu cấp phát tài sản"
          : viewMode == "recall_report"
          ? "Thêm mới yêu cầu thu hồi tài sản"
          : viewMode == "recall_confirmed"
          ? "Xác nhận thu hồi tài sản"
          : viewMode == "broken_report"
          ? "Thêm mới báo hỏng tài sản"
          : viewMode == "broken_confirmed"
          ? "Xác nhận báo hỏng tài sản"
          : "Thanh lý tài sản");
    },

    closeDialogImage() {
      this.mData.fileUploadOption.Anh.dialogImageUrl = "";
      this.mData.fileUploadOption.Anh.dialogVisible = false;
    },

    fn_uploadPreviewAnh(file) {
      this.mData.fileUploadOption.Anh.dialogImageUrl =
        ExtensionService.urlImg + file.id;
      this.mData.fileUploadOption.Anh.dialogVisible = true;
    },

    fn_removeFile(file, fileList) {
      let data = fileList.map((el) => el.id);
      this.mData.dataForm.file_ids = data;
    },

    async fn_uploadChangeFile(file, fileList) {
      if (file && file.name) {
        let lastIndexOfDot = file.name.lastIndexOf(".");
        let fileType = file.name.substr(lastIndexOfDot + 1, file.name.length);
        let typeImage = ["png", "jpg", "jpeg"];
        if (!typeImage.includes(fileType.toLowerCase())) {
          window.toastr.warning("Ảnh phải có định dạng là png, jpg hoặc jpeg");
          fileList.pop();
          return;
        }
      }
      ExtensionService.upload(file, "file_tai_san")
        .then((res) => {
          this.mData.dataForm.file_ids.push(res.result);
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption.Anh.fileList = fileList;
        })
        .catch((error) => {
          window.toastr.error("Có lỗi xảy ra!");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },

    fn_resetFormCreateAsset() {
      this.mData.dataForm = MethodService.copyObject(AssetModel.dataForm);
      this.$refs["formCreateAsset"].resetFields();
      this.$refs.upload.clearFiles();
      this.formDialog = false;
    },

    fn_resetFormManipulate() {
      this.$refs["formManipulation"].resetFields();
      if (this.mData.dataForm.employee_id) {
        this.mData.dataForm.employee_id = '';
      }
      if (this.mData.dataForm.descriptionEmployeeAsset) {
        this.mData.dataForm.descriptionEmployeeAsset = "";
      }
      if (this.mData.dataForm.description) {
        this.mData.dataForm.description = '';
      }
      this.formDialog = false;
    },

    fn_cancel() {
      if (
        this.mData.viewMode == "create" ||
        this.mData.viewMode == "update" ||
        this.mData.viewMode == "detail"
      ) {
        this.fn_resetFormCreateAsset();
        return;
      }
      this.fn_resetFormManipulate();
    },

    fn_formatCurrency(value) {
      return MethodService.formatCurrency(value);
    },

    fn_formatDate(value) {
      return MethodService.formatDate(value, "date");
    },

    fn_getCellClass({ row, column, columnIndex }) {
      return columnIndex == 7 ? "last-cell" : "";
    },

    fn_clearExpiredAtrophy() {
      this.mData.dataForm.expired_atrophy = '';
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.skip =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
        this.dataFilter.showFormSearch = this.$route.query.showFormSearch;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
        this.dataFilter.showFormSearch = this.$route.query.showFormSearch;
      }
      // if (this.$route.query.filters) {
      //   this.mData.tableRules.filters = this.$route.query.filters;
      //   // string to object
      //   this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
      //     this.mData.tableRules.filters
      //   );
      // }
      if (this.$route.query.emp_names) {
        this.mData.tableRules.dataSearch.value.emp_names = Array.isArray(
          this.$route.query.emp_names
        )
          ? this.$route.query.emp_names.join(" ")
          : this.$route.query.emp_names;
        this.dataFilter.emp_names = Array.isArray(this.$route.query.emp_names)
          ? this.$route.query.emp_names
          : [this.$route.query.emp_names];
      }
      if (this.$route.query.asset_names) {
        this.mData.tableRules.dataSearch.value.asset_names = Array.isArray(
          this.$route.query.asset_names
        )
          ? this.$route.query.asset_names.join(" ")
          : this.$route.query.asset_names;
        this.dataFilter.asset_names = Array.isArray(
          this.$route.query.asset_names
        )
          ? this.$route.query.asset_names
          : [this.$route.query.asset_names];
      }
      if (this.$route.query.identity) {
        this.mData.tableRules.dataSearch.value.identity =
          this.$route.query.identity;
        this.dataFilter.identity = this.$route.query.identity;
      }
      if (this.$route.query.is_broken == "true") {
        this.mData.tableRules.dataSearch.value.is_broken = true;
        this.dataFilter.is_broken = this.$route.query.is_broken;
      }
      if (this.$route.query.is_broken == "false") {
        this.mData.tableRules.dataSearch.value.is_broken = false;
        this.dataFilter.is_broken = this.$route.query.is_broken;
      }
      if (this.$route.query.status) {
        this.mData.dataDefault.listStatusFilter = Array.isArray(this.$route.query.status)
          ? this.$route.query.status
          : [this.$route.query.status];
        this.dataFilter.status = this.$route.query.status;
      }
      // if (this.mData.tableRules.dataSearch.value.status) {
      //   this.mData.dataDefault.listStatusFilter =
      //     this.mData.tableRules.dataSearch.value.status.split(",");
      //   this.dataFilter.status = this.$route.query.status;
      // }
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },

    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.skip =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
  },

  //run after render view
  async created() {
    await this.fn_hashUrl();
    await this.fn_initDataDefault();
    await this.fn_initTable();
  },
};
</script>
<style lang="scss" scoped>
.centerInner {
  ::v-deep .el-dialog__body {
    text-align: center;
  }
}

::v-deep .el-select {
  .el-select__tags {
    height: 37px;
    overflow: auto;
  }
}

::v-deep .el-table__fixed {
  bottom: 10px !important;
  &:before {
    background-color: transparent;
  }
}

::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 12px;
}

::v-deep .el-link.el-link--primary {
  color: #444242;
}

::v-deep .el-link.el-link--primary.is-disabled {
  color: #bebebe !important;
}

::v-deep .el-table__row {
  background-color: #fff !important;
}

.content {
  overflow: hidden;
  text-overflow: ellipsis;
}

::v-deep .el-link--primary {
  margin-left: 10px;
}

.line {
  width: 0.1px;
  height: 20px;
  background-color: var(--recall-confirmed-asset);
  margin-left: 8px;
}

::v-deep .last-cell {
  .cell {
    display: flex;
  }
}

::v-deep .el-link--inner {
  font-size: 12px;
}

.new-asset {
  color: var(--new-asset);
}

.broken-report-asset {
  color: var(--broken-report-asset);
}

.broken-confirmed-asset {
  color: var(--broken-confirmed-asset);
}

.recall-report-asset {
  color: var(--recall-report-asset);
}

.recall-confirmed-asset {
  color: var(--recall-confirmed-asset);
}

.allocation-request-asset {
  color: var(--allocation-request-asset);
}

.allocation-confirmed-asset {
  color: var(--allocation-confirmed-asset);
}

.liquidation-asset {
  color: var(--liquidation-asset);
}
</style>
